import { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function MagneticButton({ children, strength = 0.32, style = {}, className = '', ...props }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const isTouch = window.matchMedia('(pointer: coarse)').matches || window.innerWidth < 768;
    setIsTouchDevice(isTouch);
  }, []);

  const handleMouseMove = (e) => {
    if (isTouchDevice || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const dx = (e.clientX - centerX) * strength;
    const dy = (e.clientY - centerY) * strength;
    setPos({ x: dx, y: dy });
  };

  const handleMouseLeave = () => {
    if (isTouchDevice) return;
    setPos({ x: 0, y: 0 });
  };

  if (isTouchDevice) {
    return (
      <div style={{ display: 'inline-block', ...style }} className={className} {...props}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: 'spring', stiffness: 280, damping: 18, mass: 0.2 }}
      style={{ display: 'inline-block', willChange: 'transform', ...style }}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
}
